import { render, staticRenderFns } from "./FaqCategoryItem.vue?vue&type=template&id=1355bb01&scoped=true"
import script from "./FaqCategoryItem.vue?vue&type=script&lang=js"
export * from "./FaqCategoryItem.vue?vue&type=script&lang=js"
import style0 from "./FaqCategoryItem.vue?vue&type=style&index=0&id=1355bb01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355bb01",
  null
  
)

export default component.exports